export const GET_USER_ONLINE_SCREENING = `
    query getUserScreening($programId: String!) {
        getUserScreening(programID: $programId) {
            data {
                endingDate
                id
                programID
                screeningID
                startingDate
                status
            }
        }
    }
`;
